/** @file restWorld: a node's rest-pose world point, the sum of `pos` up its parent chain (no rotation). */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** Keys are absolute and `rest` drives only the facet lookup, so the rest pose has no rotation (design 4.4). */
export function restWorld(puppet: Pick<Puppet, 'nodes'>, node: string): Vec3 {
  let [x, y, z] = [0, 0, 0];
  const seen = new Set<string>();
  for (let cur: string | undefined = node; cur !== undefined && !seen.has(cur); cur = puppet.nodes[cur]?.parent) {
    seen.add(cur);
    const pos = puppet.nodes[cur]?.pos ?? [0, 0, 0];
    [x, y, z] = [x + pos[0], y + pos[1], z + pos[2]];
  }
  return [x, y, z];
}
